import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { IAdditionalProposalBO } from "@mapfre-tech/amap3";

@Injectable({
   providedIn: "root"
})
export class AdditionalProposalService {

   className = 'AdditionalProposalService';

   constructor(private http: HttpClient) { }

   //!NO se usa
   getAdditionalProposalByProgramJobId(programJobId: any): Observable<IAdditionalProposalBO[]> {
      return this.http.get<IAdditionalProposalBO[]>(environment.base_URL + "/additional-proposal/", { params: { programJobId: programJobId } });
   }

   getAdditionalProposalByJobId(jobId: number, version?: any): Observable<IAdditionalProposalBO[]> {
      const params: any = {};
      params.jobId = jobId;
      if (version) {
         params.version = version;
      }
      return this.http.get<IAdditionalProposalBO[]>(environment.base_URL + "/additional-proposal/", { params });
   }

   removeAdditionalProposalByProgramJobId(programJobId: number, code: any): Observable<IAdditionalProposalBO[]> {
      const params: any = {};
      params.code = code;
      return this.http.delete<IAdditionalProposalBO[]>(environment.base_URL + "/additional-proposal/" + programJobId, { params });
   }

   createAdditionalProposal(AdditionalProposal: IAdditionalProposalBO[]): Observable<IAdditionalProposalBO[]> {
      return this.http.post<IAdditionalProposalBO[]>(environment.base_URL + "/additional-proposal", AdditionalProposal);
   }

   updateAdditionalProposal(AdditionalProposal: IAdditionalProposalBO[]): Observable<IAdditionalProposalBO[]> {
      return this.http.put<IAdditionalProposalBO[]>(environment.base_URL + "/additional-proposal", AdditionalProposal);
   }

   export(AdditionalProposal: IAdditionalProposalBO, jobId: number): Observable<IAdditionalProposalBO[]> {
      const params = {
         jobId
      }
      const options = {
         params,
         responseType: "blob" as 'json'
      }
      return this.http.post<IAdditionalProposalBO[]>(environment.base_URL_GAIA + "/additional_proposal/" + AdditionalProposal.idAdditionalProposalPk + "/export", AdditionalProposal, options);
   }
}
